import React from "react"
import * as styles from"./cardlist.module.scss"
import { Link } from "gatsby"

// Utilities
import kebabCase from "lodash/kebabCase"
//import Img from "gatsby-image"
import getTimeToRead from "../utils/timeToRead"

const Card = ({ node }) => {
  const tags = node.frontmatter.tags || ""
  let coverImagePath = node.frontmatter.coverImg
  let descriptionText = node.frontmatter.description || node.excerpt
  return (
    <div className={`${styles.user} mb-48`}>
      <div className={styles.avatar}>
        <Link className="bs-md" to={node.fields.slug}>
          {coverImagePath ? (
			<img src={coverImagePath} />
          ) : (
            <img src="/assets/images/default.png" alt="default-img" />
          )}
        </Link>
      </div>
      <div className={styles.descriptionWrap}>
        <div className={styles.tag}>
          {tags &&
            tags.map((tag, index) => (
              <Link
                key={`${tag}-${index}`}
                aria-label={tag}
                to={`/tags/${kebabCase(tag)}/`}
              >
                {tag}
              </Link>
            ))}
        </div>
        <div className={styles.descriptionWrap}>
          <h3>
            <Link to={node.fields.slug}>
              {node.frontmatter.title || node.fields.slug}
            </Link>
          </h3>
          <p
            dangerouslySetInnerHTML={{
              __html: descriptionText,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default Card
